import { launchPanelApp } from './lib/PanelApp';
import PreLoginLayout from './pages/layout/PreLoginLayout';

// Page specific code :
import HomePage from './pages/home/Home';

launchPanelApp(HomePage, {}, PreLoginLayout);
